import { Hospital } from "@lab/types/hospitals";
import httpClient from "@lab/api/httpClient";
import { HealthService } from "@lab/types/healthservice";
import { Group } from "@lab/types/groups";
import { User } from "@lab/types/users";

const END_POINT = "/healthservices";

export const healthservice = {
	get: async (id: number): Promise<HealthService | undefined> => {
		const response = await httpClient.get(`${END_POINT}/${id}`);
		return response.data as HealthService;
	},
	groups: {
		get: async (id: number): Promise<Group[] | undefined> => {
			const response = await httpClient.get(`${END_POINT}/${id}/groups`);
			return response.data as Group[];
		}
	},
	users: {
		get: async (id: number): Promise<User[] | undefined> => {
			const response = await httpClient.get(`${END_POINT}/${id}/users`);
			return response.data as User[];
		}
	}
};
